import React, { useState, useMemo } from "react";
import "./SectionInteractive3DNew.css";
import "../../../GalleryShared.css";

/* ── Thumbnails ── */
import scooterThumb from "../../../../../Assets/Images/gallary/3d intractive/scooterthumbnail.webp";
import tableThumb    from "../../../../../Assets/Images/gallary/3d intractive/tablethumbnail.webp";

const CONFIGURATORS = [
  {
    id: "scooter",
    label: "Scooter",
    sub: "3D Product Configurator",
    url: "https://eilandigital.com/configurator/scooter/",
    thumb: scooterThumb,
    industry: "Automobile",
  },
  {
    id: "electric_table",
    label: "Electric Table",
    sub: "3D Product Configurator",
    url: "https://eilandigital.com/configurator/electric_table",
    thumb: tableThumb,
    industry: "E-commerce",
  },
];

const INDUSTRIES_INT = ["Automobile", "E-commerce"];

/* ══════════════════════════════════════════════
   STAGE + THUMB-STACK SLIDER
   Left stage shows a clickable thumbnail (opens the
   configurator URL in a new tab), right rail switches
   which configurator is active. Same shape as the
   other sections' video sliders.
══════════════════════════════════════════════ */
function InteractiveSlider({ slides }) {
  const [activeSlide, setActiveSlide] = useState(0);

  const handleThumbClick = (i) => {
    if (i === activeSlide) return;
    setActiveSlide(i);
  };

  const currentSlide = slides[activeSlide];

  /* ── Open configurator URL in new tab ── */
  const handleStageClick = () => {
    if (!currentSlide?.url) return;
    window.open(currentSlide.url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="int-vslider-wrap">
      <div className="int-vslider">

        {/* ── Left stage (clickable) ── */}
        <div
          className="int-vslider-left-wrap"
          onClick={handleStageClick}
          style={{ cursor: currentSlide?.url ? "pointer" : "default" }}
        >
          <div className="int-vslider-left">

            {/* Per-slide label — overlay pill, top-left of the stage */}
            {currentSlide?.sub && (
              <div className="int-sub-pill">{currentSlide.sub}</div>
            )}

            {slides.map((slide, i) => (
              <div
                key={slide.id}
                className={`int-vslider-vid-layer${activeSlide === i ? " int-vslider-vid-layer--active" : ""}`}
              >
                <img src={slide.thumb} alt={slide.label} className="int-stage-img" />
              </div>
            ))}

            {/* ── "Open Configurator" badge shown on hover ── */}
            {currentSlide?.url && (
              <div className="int-visit-badge">
                <svg viewBox="0 0 24 24" fill="none" width="13" height="13">
                  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <polyline points="15 3 21 3 21 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <line x1="10" y1="14" x2="21" y2="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Open Configurator
              </div>
            )}
          </div>
        </div>

        {/* ── Right thumb-stack ── */}
        <div className="int-thumb-stack">
          {slides.map((slide, i) => (
            <button
              key={slide.id}
              className={`int-thumb-stack-item${activeSlide === i ? " int-thumb-stack-item--active" : ""}`}
              onClick={() => handleThumbClick(i)}
            >
              <img src={slide.thumb} alt={slide.label} />
            </button>
          ))}
        </div>

      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════
   SECTION 3D INTERACTIVE NEW
══════════════════════════════════════════════ */
export default function SectionInteractive3DNew() {
  const [activeFilter, setActiveFilter] = useState(null);

  const visibleSlides = useMemo(() => {
    if (!activeFilter) return CONFIGURATORS;
    return CONFIGURATORS.filter((s) => s.industry === activeFilter);
  }, [activeFilter]);

  const handleFilter = (industry) => {
    setActiveFilter((prev) => (prev === industry ? null : industry));
  };

  return (
    <section className="g-section g-section--white int-section-decor">
      <div className="g-container">

        <div className="int-hdr">
          <div className="int-hdr-left">
            <h2 className="int-title">Interactive 3D</h2>
            <p className="int-desc">
              Creating immersive product experiences that enable users to
              explore, interact, and understand products beyond static
              visuals.
            </p>
          </div>

          <div className="int-filter-bar">
            {INDUSTRIES_INT.map((ind) => (
              <button
                key={ind}
                className={`int-filter-btn${activeFilter === ind ? " int-filter-btn--active" : ""}`}
                onClick={() => handleFilter(ind)}
              >
                {ind}
              </button>
            ))}
            <button
              className={`int-filter-clear${activeFilter ? " int-filter-clear--visible" : ""}`}
              onClick={() => setActiveFilter(null)}
              aria-label="Clear filter"
              tabIndex={activeFilter ? 0 : -1}
            >
              <svg viewBox="0 0 24 24" fill="none" width="13" height="13">
                <line x1="4" y1="4" x2="20" y2="20" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/>
                <line x1="20" y1="4" x2="4"  y2="20" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/>
              </svg>
            </button>
          </div>
        </div>

        <div className="int-body">
          {visibleSlides.length > 0 ? (
            <InteractiveSlider
              key={activeFilter ?? "all"}
              slides={visibleSlides}
            />
          ) : (
            <div className="int-empty">No configurators found for this category.</div>
          )}
        </div>

        <p className="int-bottom-desc">
          Applied across industries to improve product communication,
          customer engagement, and informed decision-making.
        </p>

      </div>
    </section>
  );
}